<script setup>
// E-mail aos administradores quando a conexão do canal cai
// (`inboxes.disconnect_email_enabled`). Tem cliente que não quer o aviso de
// canal que não acompanha (número de teste, Baileys abandonado).
//
// Salva ao alternar: chave de liga/desliga que só vale depois de um "Atualizar"
// lá embaixo mostra um estado que ainda não existe. Desligar tira SÓ o e-mail —
// o banner de reconectar continua (Reauthorizable).
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'dashboard/composables/store';
import { toast } from 'dashboard/helper/toast';
import SettingsSection from 'dashboard/components/SettingsSection.vue';
import Switch from 'dashboard/components-next/switch/Switch.vue';

const props = defineProps({
  inbox: {
    type: Object,
    default: () => ({}),
  },
});

const { t } = useI18n();
const store = useStore();

// Ausente (inbox em cache de antes do campo existir) = ligado, que é o default
// da coluna.
const enabled = ref(props.inbox.disconnect_email_enabled !== false);
const isSaving = ref(false);

watch(
  () => props.inbox.disconnect_email_enabled,
  value => {
    enabled.value = value !== false;
  }
);

const onToggle = async value => {
  enabled.value = value;
  isSaving.value = true;
  try {
    await store.dispatch('inboxes/updateInboxSetting', {
      id: props.inbox.id,
      disconnect_email_enabled: value,
    });
    toast.success(
      value
        ? t('INBOX_MGMT.SETTINGS_POPUP.DISCONNECT_EMAIL.ENABLED')
        : t('INBOX_MGMT.SETTINGS_POPUP.DISCONNECT_EMAIL.DISABLED')
    );
  } catch (error) {
    // A chave volta: ela não pode mostrar o que não foi salvo.
    enabled.value = !value;
    toast.error(
      error?.message || t('INBOX_MGMT.SETTINGS_POPUP.DISCONNECT_EMAIL.ERROR')
    );
  } finally {
    isSaving.value = false;
  }
};
</script>

<template>
  <SettingsSection
    :title="t('INBOX_MGMT.SETTINGS_POPUP.DISCONNECT_EMAIL.TITLE')"
    :sub-title="t('INBOX_MGMT.SETTINGS_POPUP.DISCONNECT_EMAIL.SUB_TEXT')"
    :show-border="false"
  >
    <div class="flex items-center gap-2 pb-2">
      <Switch
        id="disconnectEmailEnabled"
        :model-value="enabled"
        :disabled="isSaving"
        @update:model-value="onToggle"
      />
      <label
        for="disconnectEmailEnabled"
        class="text-sm text-n-slate-12 cursor-pointer"
      >
        {{ t('INBOX_MGMT.SETTINGS_POPUP.DISCONNECT_EMAIL.LABEL') }}
      </label>
    </div>
    <p class="pb-1 text-sm text-n-slate-11">
      {{ t('INBOX_MGMT.SETTINGS_POPUP.DISCONNECT_EMAIL.HELP_TEXT') }}
    </p>
  </SettingsSection>
</template>
